import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
                    
datadogRum.init({
  applicationId: '434c371a-3b7e-45bb-956a-1d5485f904da',
  clientToken: 'pub433ab38f4ba592643a433e6e64bb9168',
  site: 'datadoghq.com',
  service: import.meta.env.VITE_DATADOG_SERVICE_NAME,
  env: import.meta.env.VITE_CURRENT_ENV,
  version: __APP_VERSION__,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackResources: true,
  trackUserInteractions: true,
  trackLongTasks: true,
  plugins: [reactPlugin({ router: false })],
});
